import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const Callback: React.FC = () => {
  const { isLoading, error } = useAuth0();

  if (error) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h2>Authentication Error</h2>
        <div style={{ color: 'red' }}>{error.message}</div>
        <div style={{ marginTop: '20px', fontSize: '14px' }}>
          <strong>Error details:</strong>
          <pre style={{ textAlign: 'left', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
            {JSON.stringify(error, null, 2)}
          </pre>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h2>Processing login...</h2>
        <div>Please wait while we complete your authentication...</div>
      </div>
    );
  }

  // If not loading and no error, redirect to home
  window.location.replace('/');
  return null;
};